import './app.scss'
import './bootstrap.js'
/*import './mdb.js'*/
import {initMDB, Alert, Button, Collapse, Dropdown, Input, Modal, Navbar, Offcanvas, Popover, Ripple, ScrollSpy, Select, Sidenav, Tab, Toast} from "./mdb.js";
import {createI18n} from "vue-i18n";
import PrimeVue from 'primevue/config';
import de from "./i18n/de.js";
import en from "./i18n/en.js";

initMDB({Alert, Button, Collapse, Dropdown, Input, Modal, Navbar, Offcanvas, Popover, Ripple, ScrollSpy, Select, Sidenav, Tab, Toast});

/**
 * VUE JS I18N SUPPORT
 */
document.addEventListener('vue:before-mount', (event) => {
    const {
        componentName, // The Vue component's name
        component, // The resolved Vue component
        props, // The props that will be injected to the component
        app, // The Vue application instance
    } = event.detail;

    const i18n = createI18n({
        locale: document.querySelector('html[lang]')?.getAttribute('lang') ?? 'de',
        fallbackLocale: 'de',
        messages: {
            de: {...de},
            en: {...en}
        }
    });

    app.use(i18n);
    app.use(PrimeVue, { unstyled: true });
});

const sidebarToggle = document.getElementById("sidebar-toggle");
const toggleSidebar = () => {
    const sidebarState = window.localStorage.getItem('sidebar-state') === 'open' ? 'closed' : 'open';

    document.documentElement.dataset.sidebarState = sidebarState;
    window.localStorage.setItem('sidebar-state', sidebarState);

    const instance = Sidenav.getInstance(document.getElementById('main-sidenav'));
    instance.toggleSlim();

    fetch('/api/preferences', {
        method: 'POST',
        body: JSON.stringify({
            "sidebarState": sidebarState
        })
    });
}
if (sidebarToggle){
    // add listener to theme toggler
    sidebarToggle.addEventListener("click", () => {
        toggleSidebar();
    });
}

// close modal on click any item
document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('#categoriesNav li a');
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
        Modal.getInstance(document.getElementById('categoriesNav')).hide();
        });
    });
});



// Debounce-Funktion
function debounce(fn, delay) {
    let timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
    }
}

// Filter-Funktion
const filterProducts = () => {
    const search = document.getElementById('product-search').value.toLowerCase().trim();
    const categories = document.querySelectorAll('[data-searchable-products]');

    categories.forEach(category => {
        const products = category.querySelectorAll('[data-searchable-product]');
        let visibleProducts = 0;

        products.forEach(product => {
            const nr = product.querySelector('.product-nr')?.textContent.toLowerCase() ?? '';
            const name = product.querySelector('.product-name')?.textContent.toLowerCase() ?? '';
            const match = nr.includes(search) || name.includes(search);
            product.style.display = match ? '' : 'none';
            if (match) visibleProducts++;
        });
        const header = document.getElementById(category.id + '-header');
        const showCategory = visibleProducts > 0;

        category.style.display = showCategory ? '' : 'none';
        category.style.setProperty('padding', showCategory ? '' : '0px', 'important');

        if (header) header.style.display = showCategory ? '' : 'none';

        const navLink = document.querySelector(`[data-searchable-products-cat-nav="${category.id}"]`);
        if (navLink) {
            // console.log(navLink);
            navLink.style.display = showCategory ? '' : 'none';
        }
    });
}
document.getElementById('product-search')?.addEventListener('input', debounce(filterProducts, 200));
